export default __webpack_public_path__ + "assets/images/f8036822c3800f9ad8fb905a4ac31ae1.svg";